const HOUSE_TYPES = Object.freeze({
  HOUSE: 'Casa',
  APARTMENT: 'Apartamento',
  CONDO_HOUSE: 'CasaCondominio',
  STUDIO: 'StudioOuKitchenette',
});

export default HOUSE_TYPES;
